import { FC, PropsWithChildren } from 'react';

import styles from './nav-menu.module.scss';

export const NavMenu: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
